import {AgGridReact} from "ag-grid-react";
import React, {useMemo, useState} from "react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import Default from "./cell-renderers/default.jsx";
import Icon from "./cell-renderers/icon.jsx";
import vmsService from "../../../../services/web/vms-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const TableCameras = ({cameras, gridRef}) => {

    const [columnDefs, ] = useState([
        {
            headerName: "",
            field: "iconColor",
            width: 50,
            cellRenderer: Icon
        },
        {
            headerName: "ID",
            field: "id",
            comparator: aggridUtils.nullLastComparator,
            width: 75,
            cellRendererParams: {center: true},
            cellRenderer: Default
        },
        {
            headerName: "Nome da câmera",
            field: "cameraName",
            comparator: aggridUtils.nullLastComparator,
            flex: 3,
            cellRenderer: Default,
        },
        {
            headerName: "Tipo",
            field: "type",
            comparator: aggridUtils.nullLastComparator,
            cellRenderer:  ({value}) => {
                return value === "FIXED" ? "Fixo" : "Móvel"
            },
        },
        {
            headerName: "Marcadores",
            field: "labels",
            comparator: aggridUtils.nullLastComparator,
            cellRenderer: Default,
            width: 175,
        },
        {
            headerName: "VMS",
            field: "vmsName",
            comparator: aggridUtils.nullLastComparator,
            flex: 1,
            cellRenderer: Default
        },
        {
            headerName: "Gravador",
            field: "dvrName",
            comparator: aggridUtils.nullLastComparator,
            cellRenderer: Default,
        },
    ]);

    const defaultColDef = useMemo(() => {
        return {
            filter: false,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true,
            suppressHeaderContextMenu: true,
            suppressFloatingFilterButton: true,
        };
    }, []);

    const onCellClicked = async ({data}) => {
        const vmsTab = window.open("", "_blank");
        vmsTab.opener = null;
        axios.get(`${API_URL}/vms/access-from-video-camera/${data.vmsId}/${data.id}`)
            .then(({data}) => {
                vmsTab.location.href = data;
            })
            .catch(() => {
                vmsTab.close();
                projectUtils.swalErrorMessage("", "Não foi possível abrir o VMS.", "Ok");
            })
    }

    return (
        <>
            <div className={`aggrid-row-pointer`} style={{height: 'calc(100vh - 153px)'}}>
                <AgGridReact
                    ref={gridRef}
                    rowData={cameras}
                    columnDefs={columnDefs}
                    onCellClicked={onCellClicked}
                    suppressHeaderFocus={true}
                    defaultColDef={defaultColDef}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{localeText: aggridUtils.localization()}}
                    theme={aggridUtils.generalTheme()}
                />
            </div>
        </>
    );
}

export default TableCameras;